<template>
  <svg
    :width="width + margin.left + margin.right"
    :height="height + margin.top + margin.bottom"
    @mousemove="onMouseMove"
    @mouseleave="onMouseLeave"
    @touchmove="onMouseMove"
    ref="chart"
  >
    <g v-if="hoverIndex !== null" :transform="'translate(' + (genScale.x(activeIndex) + margin.left) + ',' + ( margin.top ) + ')'">
      <line :y2="height" class="grid" stroke-dasharray="2,2"/>
      <text class="label" :y="this.height + 15" text-anchor="middle">{{ points[activeIndex].date | formatDate }} </text>
    </g>
    <g :transform="'translate(' + margin.left + ', ' + margin.top + ')'">
      <path class="sparkline" stroke="black" fill="none" :d="genPath" />
      <g :transform="genSpotTransform">
        <circle r="4" class="spot" />
        <text x="5" y="-5" class="note">
          {{ points[activeIndex].estimate | probability(1) }}
        </text>
      </g>
    </g>
  </svg>
</template>

<script>
import * as d3 from "d3";
import { max, min, map, keys } from "lodash";

export default {
  props: ["points"],
  data() {
    return {
      width: 150,
      height: 20,
      margin: {
        left: 15,
        right: 60,
        top: 20,
        bottom: 15,
      },
      hoverIndex: null,
    };
  },
  computed: {
      activeIndex () {
        if (this.hoverIndex === null) {
            return this.points.length - 1;
        } else {
            return this.hoverIndex;
        }
      },
    genScale() {
      let estimates = map(this.points, "estimate")
      let max_estimate = max(estimates);
      let min_estimate = min(estimates);

      return {
        x: d3
          .scaleLinear()
          .domain([0, this.points.length])
          .range([0, this.width]),
        y: d3.scaleLinear().domain([min_estimate, max_estimate]).range([this.height, 0]),
      };
    },
    genPath() {
      let d = map(keys(this.points), (i) => ({
        x: parseInt(i),
        y: this.points[i].estimate,
      }));

      let scale = this.genScale;

      let line = d3
        .line()
        .x((d) => scale.x(d.x))
        .y((d) => scale.y(d.y));

      return line(d);
    },
    genSpotTransform() {
      let scale = this.genScale;

      return (
        "translate(" +
        scale.x(this.activeIndex) +
        "," +
        scale.y(this.points[this.activeIndex].estimate) +
        ")"
      );
    },
  },
  methods: {
    onMouseMove(event) {
      if (window.TouchEvent && event instanceof TouchEvent) event = event.touches[0];
      let pointer = d3.pointer(event, this.$refs.chart);

      let coords = [
        pointer[0] - this.margin.left,
        pointer[1] - this.margin.top,
      ];

      if (coords[0] < 0 || coords[1] < 0 || coords[1] > this.height || coords[1] > this.width) {
          this.hoverIndex = null;
          return;
      }

      let xScale = this.genScale.x;

      let index = Math.round(xScale.invert(coords[0]));

      this.hoverIndex = Math.max(Math.min(index, this.points.length - 1), 0);
    },
    onMouseLeave () {
        this.hoverIndex = null;
    },
  },
  filters: {
    formatDate(x) {
      return d3.timeFormat("%d.%m%")(d3.isoParse(x.substr(0, 10)));
    }
  }
};
</script>

<style>
svg {
    touch-action: pan-y;
}
</style>